import { isMobile } from "../utils/is-mobile";

function parseWKT(wkt) {
	wkt = wkt.trim();

	if (/^POLYGON/i.test(wkt)) {
		return parsePolygon(wkt);
	}

	if (/^MULTIPOLYGON/i.test(wkt)) {
		const body = wkt
			.replace(/^MULTIPOLYGON\s*\(\(\(/i, '')
			.replace(/\)\)\)\s*$/, '');

		return body
			.split(/\)\s*\)\s*,\s*\(\s*\(/)
			.map(p => parsePolygon(`POLYGON((${p}))`)[0]);
	}

	return [];
}

function parsePolygon(wkt) {
	const body = wkt
		.replace(/^POLYGON\s*\(\(/i, '')
		.replace(/\)\)\s*$/, '');

	const outerRingText = body.split(/\)\s*,\s*\(/)[0];

	const outerRing = outerRingText.split(',').map(pair => {
		const [lng, lat] = pair.trim().split(/\s+/).map(Number);
		return { lat, lng };
	});

	return [outerRing];
}

async function parseWKTFromFile( filePath ) {
	const response = await fetch( filePath );
	const data = await response.text();
	return parseWKT( data );
}

const initMap = async function( $block ) {
	const { Map } = await google.maps.importLibrary("maps");
	const $map = $block.find( "#map" );

	if ( !$map.length ) { return false; }

	const $mapElements = $block.find( ".map-coord-js" );

	var markers = [];

	async function loadMap() {
		var styleArray = [
			{elementType: "geometry", stylers: [{color: "#f6f7f0"}]},
			{elementType: "labels.text.fill", stylers: [{color: "#949494"}]},
			{featureType: "poi", stylers: [{visibility: "off"}]},
			{featureType: "road", elementType: "geometry", stylers: [{color: "#d5d5d3"}]},
			{featureType: "road", elementType: "geometry.stroke", stylers: [{color: "#d5d5d3"}]},
			{featureType: "road", elementType: "labels", stylers: [{visibility: "off"}]},
			{featureType: "road.highway", elementType: "geometry", stylers: [{color: "#f6f7f0"}]},
			{featureType: "road.highway", elementType: "geometry.stroke", stylers: [{color: "#d5d5d3"}]},
			{featureType: "road.highway", elementType: "labels", stylers: [{visibility: "off"}]},
			{featureType: "transit", elementType: "geometry", stylers: [{color: "#c5d7ad"}]},
			{featureType: "transit.station", elementType: "labels", stylers: [{visibility: "off"}]},
			{featureType: "water", elementType: "geometry", stylers: [{color: "#c5d7ad"}]},
			{featureType: "water", elementType: "labels", stylers: [{visibility: "off"}]}
		];

		var winWidth = jQuery( window ).width();

		var zoom = ( winWidth > 768 ) ? 8 : 7;

		var map = new google.maps.Map( $map[0], {
			center: { lat: 34.4000, lng: -81.700 },
			zoom: zoom,
			mapTypeControl: false,
			zoomControl: true,
			styles: styleArray
		} );

		var wktGreenville = "/wp-content/themes/buildonyourland/src/js/polygons//greenville.wkt";
		var wktColumbia = "/wp-content/themes/buildonyourland/src/js/polygons//columbia.wkt";
		var wktAiken = "/wp-content/themes/buildonyourland/src/js/polygons//aiken.wkt";

		const greenvilleCoords = await parseWKTFromFile( wktGreenville );
		const columbiaCoords = await parseWKTFromFile( wktColumbia );
		const aikenCoords = await parseWKTFromFile( wktAiken );



		var greenvillePolygon = new google.maps.Polygon( {
			paths: greenvilleCoords,
			strokeColor: "#628533",
			strokeOpacity: 0.8,
			strokeWeight: 2,
			fillColor: "#628533",
			fillOpacity: 0.35,
			map: map
		} );

		var columbiaPolygon = new google.maps.Polygon( {
			paths: columbiaCoords,
			strokeColor: "#628533",
			strokeOpacity: 0.8,
			strokeWeight: 2,
			fillColor: "#628533",
			fillOpacity: 0.35,
			map: map
		} );

		var aikenPolygon = new google.maps.Polygon( {
			paths: aikenCoords,
			strokeColor: "#628533",
			strokeOpacity: 0.8,
			strokeWeight: 2,
			fillColor: "#628533",
			fillOpacity: 0.35,
			map: map
		} );

		greenvillePolygon.setMap( null );
		columbiaPolygon.setMap( null );
		aikenPolygon.setMap( null );

		$mapElements.each( function( index, element ) {
			var marker = new google.maps.Marker( {
				position: { lat: parseFloat( element.dataset.lat ), lng: parseFloat( element.dataset.lng ) },
				map: map,
				icon: {
					url: element.dataset.marker
				},
			} );

			markers.push( marker );
		} );

		markers.forEach( function( marker, index ) {
			if ( isMobile() ) {
				google.maps.event.addListener( marker, "click", function() {
					handleMarkerClick( index );
					smoothPanTo( marker.getPosition(), map );
				} );
			} else {
				google.maps.event.addListener( marker, "mouseover", function() {
					handleMarkerClick( index );
					smoothPanTo( marker.getPosition(), map );
				} );
			}
		} );

		function smoothPanTo( position, map ) {
			var start = Date.now();
			var duration = 150;
			var startLatLng = map.getCenter();
			var startLat = startLatLng.lat();
			var startLng = startLatLng.lng();
			var endLat = position.lat();
			var endLng = position.lng();

			function moveStep() {
				var progress = ( Date.now() - start ) / duration;
				if ( progress < 1 ) {
					var lat = startLat + progress * ( endLat - startLat );
					var lng = startLng + progress * ( endLng - startLng );
					var newCenter = new google.maps.LatLng( lat, lng );
					map.panTo( newCenter );
					requestAnimationFrame( moveStep );
				} else {
					map.panTo( position );
				}
			}

			moveStep();
		}

		function handleMarkerClick( markerIndex ) {
			map.setZoom( 8 );

			if ( markerIndex === 0 ) {
				greenvillePolygon.setMap( map );
				columbiaPolygon.setMap( null );
				aikenPolygon.setMap( null );
			} else if ( markerIndex === 1 ) {
				columbiaPolygon.setMap( map );
				greenvillePolygon.setMap( null );
				aikenPolygon.setMap( null );
			} else if ( markerIndex === 2 ) {
				aikenPolygon.setMap( map );
				columbiaPolygon.setMap( null );
				greenvillePolygon.setMap( null );
			}
		}

		var $greenville = $( ".map-coord-0" );
		var $columbia = $( ".map-coord-1" );
		var $aiken = $( ".map-coord-2" );

		function clickHandler() {
			map.setZoom( 8 );

			if ( this === $greenville[0] ) {
				greenvillePolygon.setMap( map );
				columbiaPolygon.setMap( null );
				aikenPolygon.setMap( null );
			} else if ( this === $columbia[0] ) {
				columbiaPolygon.setMap( map );
				greenvillePolygon.setMap( null );
				aikenPolygon.setMap( null );
			} else if ( this === $aiken[0] ) {
				aikenPolygon.setMap( map );
				columbiaPolygon.setMap( null );
				greenvillePolygon.setMap( null );
			}
		}

		if ( isMobile() ) {
			$greenville.on( "click", clickHandler );
			$columbia.on( "click", clickHandler );
			$aiken.on( "click", clickHandler );

			$( ".map-coord-js" ).on( "click", function() {
				var lat = parseFloat( $( this ).data( "lat" ) );
				var lng = parseFloat( $( this ).data( "lng" ) );
				var latLng = new google.maps.LatLng( lat, lng );

				map.panTo( latLng );

				$( "html, body" ).animate( {
					scrollTop: $( "#map" ).offset().top - $( ".header" ).height()
				}, 1000 );

			} );
		} else {
			$greenville.on( "mouseover", clickHandler );
			$columbia.on( "mouseover", clickHandler );
			$aiken.on( "mouseover", clickHandler );

			$( ".map-coord-js" ).on( "mouseover", function() {
				var lat = parseFloat( $( this ).data( "lat" ) );
				var lng = parseFloat( $( this ).data( "lng" ) );
				var latLng = new google.maps.LatLng( lat, lng );

				map.panTo( latLng );

			} );
		}

	}

	loadMap();

};

themeUtils.loadBlock( initMap, "contacts", ".contacts" );

$( window ).on( "load", function() {
	$( ".contacts__item--btn" ).on( "click", function() {
		var $parent = $( this ).parent();
		$( ".contacts__item--dropdown" ).not( $parent ).removeClass( "dropdown-show" );
		$(".contacts__item--menu").not($parent.find(".contacts__item--menu")).slideUp();
		$( ".contacts__item--menu--elem" ).removeClass( "active" );
		$( ".contacts__item--menu--elem" ).children( "ul" ).hide(300);
		$parent.toggleClass("dropdown-show");
		$(this).next().slideToggle();
	} );

	$( document ).click( function( e )  {
		var container = $( ".contacts__item--dropdown" );

		if ( !container.is( e.target ) && container.has( e.target ).length === 0 ) {
			container.removeClass( "dropdown-show" );
			$( ".contacts__item--menu" ).slideUp();
			$( ".contacts__item--menu--elem" ).removeClass( "active" );
			$( ".contacts__item--menu--elem" ).children( "ul" ).hide(300);
		}

	} );

	$( ".contacts__item--menu--elem" ).on( "click", function() {
		var $this = $( this );
		$( ".contacts__item--menu--elem" ).not( $this ).removeClass( "active" );
		$( ".contacts__item--menu--elem" ).not( $this ).children( "ul" ).hide(300);
		$this.toggleClass( "active" );
		$this.children( "ul" ).toggle(300);
	} );

} );